import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { InvoiceRow, InvoiceTableHeadRow } from '../../assets';
import { calculateInvoicingValues } from 'components/modules/EditHarvestSummaryModal/utils';
import NotesNdTotal from './NotesNdTotal';

// Create styles
const styles = StyleSheet.create({
  itemDetails: {
    width: 547, // Fit within page padding
    backgroundColor: '#FFFCE8',
    borderRadius: 12,
    marginBottom: 5, // Further reduced to give maximum space for footer
  },
  impactTextTitileBtm: {
    color: '#53575A',
    fontFamily: 'Trebuchet',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 'bold',
  },
  textTitle: {
    padding: '16px 24px',
  },
  bottomRound: {
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
type PdfHarvestSummaryReportProps = {
  reportData: any;
};

// Create Document Component
const Invoicing = ({ reportData }: PdfHarvestSummaryReportProps) => {
  // Sort the details array
  const details = React.useMemo(() => {
    if (!reportData?.details) return [];

    return [...reportData.details].sort((a: any, b: any) => {
      // Priority sort if available, else natural alphanumeric by name
      const priorityA = a?.sku?.priority ?? Number.POSITIVE_INFINITY;
      const priorityB = b?.sku?.priority ?? Number.POSITIVE_INFINITY;
      if (priorityA !== priorityB) return priorityA - priorityB;
      const nameA = a?.sku?.name ?? '';
      const nameB = b?.sku?.name ?? '';
      return String(nameA).localeCompare(String(nameB), undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    });
  }, [reportData?.details]);
  const values = calculateInvoicingValues(
    details,
    reportData?.site,
    reportData?.reportType,
  );

  return (
    <View>
      <View style={styles.itemDetails}>
        <View style={styles.textTitle}>
          <Text style={styles.impactTextTitileBtm}>Invoicing</Text>
        </View>
        <View
          style={{
            padding: 2, // Further reduced to give maximum space for footer
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <View style={styles.bottomRound}>
            <InvoiceTableHeadRow reportType={reportData?.reportType} />
            {details.map((item: any, index: number) => {
              return (
                <InvoiceRow
                  isOdd={index % 2 === 0}
                  row={item}
                  isTotal={false}
                  site={reportData?.site}
                  reportType={reportData?.reportType}
                />
              );
            })}
            <InvoiceRow
              isTotal
              row={values}
              reportType={reportData?.reportType}
            />
          </View>
        </View>
        <NotesNdTotal reportData={reportData} />
      </View>
    </View>
  );
};

export default Invoicing;
